// @ts-check
import ShrinkWrap from 'Components/Common/ShrinkWrap';
import ListBox from 'Components/Common/listBox';
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/comboBoxSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from 'mobx-react';
import React from "react";

/**
 * @param {{
 * id?: string,
 * title: string,
 * helperText?: string,
 * selectedItem: any,
 * values: {key: any}[],
 * onSelectedItemChanged: (arg0: any) => void,
 * emptyPlaceholder?: string,
 * buttonId?: string,
 * buttonValue?: string,
 * buttonDisabled?: boolean,
 * buttonClick?: () => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const ComboBoxSetting = (props) => {
    return (
        <div className='setting-container combobox-setting'>

            <div className='setting-title combobox-setting-title'>
                <ShrinkWrap>
                    {props.title}
                </ShrinkWrap>
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>

            <div className='combobox-setting-value-block'>
                <ListBox
                    id={props.id}
                    values={props.values}
                    selectedItem={props.selectedItem}
                    onSelectedItemChanged={props.onSelectedItemChanged}
                    emptyPlaceholder={props.emptyPlaceholder} />

                {
                    props.buttonValue ?
                        <button
                            id={props.buttonId}
                            onClick={(e) => props.buttonClick?.()}
                            className={props.buttonDisabled ? 'disabled' : ''}>
                            {props.buttonValue}
                        </button>
                        : ''
                }
            </div>

        </div>
    )
}

export default observer(ComboBoxSetting);